import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { SessionOptionsService } from '../../../core/services/session-option.service';
import { ArcAngelService } from '../../../core/services/arc-angel.service';
import { DataContextService } from '../../../core/services/data-context.service';
import { WindowService } from '../../../core/services/window.service';

import { FormsModule } from '@angular/forms';
import { OrganizationService } from '../../../core/services/organization.service';
import { ArcAngelPapiService } from '../../../core/services/arc-angel-papi.service';
import { ArcAngelMonitorModeService } from '../arc-angel-monitor-mode.service';

@Component({
  selector: 'app-safezone-visualizer',
  standalone: true,
  imports: [
    FormsModule
],
  templateUrl: './safezone-visualizer.html.component.html',
  styleUrl: './safezone-visualizer.html.component.css'
})
export class SafezoneVisualizerHtmlComponent implements OnInit, OnChanges {
  @Input() mapEntity: any;

  updating = false;
  showButtons = false;

  private activateInterval: any;
  private deactivateInterval: any;
  private orgId: string = '';

  constructor(
    private dataContext: DataContextService,
    private windowService: WindowService,
    private arcAngelService: ArcAngelService,
    private organizationService: OrganizationService,
    private sessionOptionsService: SessionOptionsService,
    private arcAngelMonitorModeService: ArcAngelMonitorModeService,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['mapEntity'] && this.mapEntity) {
      const mapEntityId = this.mapEntity?.attributes?.[0]?.mapEntityId;

      if (mapEntityId) {
        const entity = this.dataContext.getMapEntity(mapEntityId);
        this.mapEntity = entity?.arcLiveMapEntity || entity;
      }

      this.showButtons = this.sessionOptionsService.isLiveMode();
    }
  }

  ngOnInit(): void {
    const mapEntityId = this.mapEntity.attributes[0].mapEntityId
    const entity = this.dataContext.getMapEntity(mapEntityId);
    this.mapEntity = entity?.arcLiveMapEntity || entity;
    this.showButtons = this.sessionOptionsService.isLiveMode();
    this.orgId = this.arcAngelMonitorModeService.getOrgIdForLiveIncident(this.mapEntity.eventId) || '';
  }

  activateSafezone(): void {
    if (!this.mapEntity) return;
    this.updating = true;

    this.organizationService
      .activateSafezone(this.mapEntity.eventId, this.mapEntity.arcAngelId, this.orgId)
      .subscribe({
        next: (response) => {
          // Update mapEntity directly
          this.mapEntity.isActive = response.active;
          // Call existing handler if needed
          this.handleStatusChange();

          this.updating = false;
        },
        error: (err) => {
          alert('Error: ' + err.statusText);
          this.updating = false;
        }
      });
  }


  deactivateSafezone(): void {
    if (!this.mapEntity) return;
    this.updating = true;

    this.organizationService
      .deactivateSafezone(this.mapEntity.eventId, this.mapEntity.arcAngelId, this.orgId)
      .subscribe({
        next: (response) => {
          // Update the mapEntity directly
          this.mapEntity.isActive = response.active;

          // Call existing handler if needed
          this.handleStatusChange();

          this.updating = false;
        },
        error: (err) => {
          alert('Error: ' + err.statusText);
          this.updating = false;
        }
      });
  }

  private handleStatusChange(): void {
    const mapEntityId = this.mapEntity?.attributes?.[0]?.mapEntityId;
    if (!mapEntityId) return;

    // Refresh from DataContext
    const updated = this.dataContext.getMapEntity(mapEntityId);
    this.mapEntity = updated?.arcLiveMapEntity || updated;

    this.updating = false;
  }


  deleteSafezone(): void {
    if (!this.mapEntity) return;

    const confirmDelete = confirm(
      `Are you sure you want to delete the safezone named ${this.mapEntity.getName()}?`
    );

    if (confirmDelete) {
      this.windowService.closeMapEntityDetailsWindow(this.mapEntity.getWindowId());
      this.arcAngelService
        .deleteSafeZone(this.mapEntity.getEventId(), this.mapEntity.getArcAngelId())
        .then(() => {
          this.dataContext.removeMapEntity(this.mapEntity);
        })
        .catch((errResponse: any) => {
          alert('Error: ' + errResponse.statusText);
        });
    }
  }

  ngOnDestroy(): void {
    if (this.activateInterval) clearInterval(this.activateInterval);
    if (this.deactivateInterval) clearInterval(this.deactivateInterval);
  }

}
